import React from 'react'
import { ProductStatusDisplay } from '@src/type/product'
import type { Product } from '@src/type/product'
import styled from '@emotion/styled'
import { IMG_STORAGE_URL } from '@src/utils/constants'

type PropsType = {
	product?: Product | null
}
const ProductInfo = ({ product }: PropsType) => {
	return (
		<Section>
			{product && (
				<>
					<SectionLeft>
						<ImgWrapper>
							<ProductBannerImg
								src={`${IMG_STORAGE_URL}/commerce/product/banner_img/${product.banner_img[0]}`}
								alt={`${product.title} thumbnail`}
							/>
						</ImgWrapper>
					</SectionLeft>

					<SectionRight>
						<FieldWrapper>
							<FieldTitle>상품명 : </FieldTitle>
							<FieldValue>{product.title}</FieldValue>
						</FieldWrapper>
						<FieldWrapper>
							<FieldTitle>상품상태 : </FieldTitle>
							<FieldValue>{ProductStatusDisplay[product.status]}</FieldValue>
						</FieldWrapper>
					</SectionRight>
				</>
			)}
		</Section>
	)
}

const Section = styled.section`
	display: flex;
	width: 100%;
`
const SectionLeft = styled.div`
	width: 30%;
`
const ImgWrapper = styled.div`
	position: relative;
	width: 100%;
	display: inline-block;
`
const ProductBannerImg = styled.img`
	width: 100%;
	height: 100%;
`
const SectionRight = styled.div`
	width: 70%;
	padding: 2rem;
`
const FieldWrapper = styled.div`
	margin-bottom: 1rem;
`
const FieldTitle = styled.span`
	font-size: 1.8rem;
`
const FieldValue = styled.span`
	font-size: 1.6rem;
	word-break: break-all;
`

export default ProductInfo
